/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type PortfolioEvaluationItemEvaluationType =
  (typeof PortfolioEvaluationItemEvaluationType)[keyof typeof PortfolioEvaluationItemEvaluationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PortfolioEvaluationItemEvaluationType = {
  InvestorType: "InvestorType",
  CustomerCategory: "CustomerCategory",
  RiskToleranceType: "RiskToleranceType",
  LossCapabilityType: "LossCapabilityType",
  InvestmentPreferenceType: "InvestmentPreferenceType",
  ESGType: "ESGType",
  InvestmentHorizon: "InvestmentHorizon",
  PayoutHorizon: "PayoutHorizon",
  ESGEUType: "ESGEUType",
  ESGConsequenceType: "ESGConsequenceType",
  ESGConsequenceSubType: "ESGConsequenceSubType",
  Knowledge: "Knowledge",
  Experience: "Experience",
  FinancialSituationType: "FinancialSituationType",
  RiskProfileType: "RiskProfileType",
  Aml: "Aml",
  AmlQuestionnaireType: "AmlQuestionnaireType",
  AmlInvestmentAllocationType: "AmlInvestmentAllocationType",
  AmlInvestmentCaseType: "AmlInvestmentCaseType",
  AmlClientRiskProfile: "AmlClientRiskProfile",
  AmlBusinessRiskProfile: "AmlBusinessRiskProfile",
  AmlControlLevel: "AmlControlLevel",
} as const;
